import { OfferInformationTable } from "components/Tables/OfferInformationTable/OfferInformationTable.tsx";
import { FC } from "react";

interface InformationSectionProps {
    offerId: string;
}

export const InformationSection: FC<InformationSectionProps> = ({ offerId }) => {
    return (
        <div className="overflow-y-auto">
            <OfferInformationTable offerId={offerId} />
        </div>
    );
};
